import React, { ReactNode, useState } from "react";
import ComponentMenu from "../ComponentMenu/ComponentMenu";
import Header from "../Header/Header";

import { style, classes } from "./layout.st.css";

interface LayoutProps {
  /** Is component menu displayed */
  componentMenu?: boolean;
  children: ReactNode;
  className?: string;
}

const Layout = ({
  children,
  componentMenu,
  className,
  ...rest
}: LayoutProps) => {
  /** devMode allows the page to be viewed 100% width with no sidebar */
  const [devMode, setDevMode] = useState(false);
  /** Mobile menu toggle button to toggle side nav */
  const [mobileMenu, setMobileMenu] = useState(false);

  return (
    <div
      className={style(classes.root, { devMode, mobileMenu }, className)}
      {...rest}
    >
      <Header
        mobile={mobileMenu ? true : undefined}
        menuToggle={componentMenu}
        toggleDevMode={() => setDevMode(!devMode)}
        toggleSideNav={() => setMobileMenu(!mobileMenu)}
      />
      <section className={classes.grid}>
        {componentMenu && <ComponentMenu className={classes.componentMenu} />}
        <section className={classes.content}>
          <main className={classes.bodyArea}>{children}</main>
        </section>
      </section>
    </div>
  );
};

export default Layout;
